var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node-view-wrapper',{staticClass:"tiptap-config"},[(_vm.isGrowthInvest() && _vm.editor.options.editable)?_c('tiptap-config-options',{attrs:{"options":_vm.options,"update-attributes":_vm.updateAttributes,"json":_vm.editor.getJSON()}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }